import { render, staticRenderFns } from "./goodsMax.vue?vue&type=template&id=d01f9ac2&scoped=true"
import script from "./goodsMax.vue?vue&type=script&lang=js"
export * from "./goodsMax.vue?vue&type=script&lang=js"
import style0 from "./goodsMax.vue?vue&type=style&index=0&id=d01f9ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01f9ac2",
  null
  
)

export default component.exports